export default __webpack_public_path__ + "static/media/templately.1693fcf8.svg";